import { getAnalytics } from 'firebase/analytics';
import { app } from '../config';

const analytics = getAnalytics(app);
export { analytics };
